<template>
  <div class="thousand props-group">
    <el-form-item label="使用千分位">
      <el-checkbox v-model="component.properties.bit"></el-checkbox>
    </el-form-item>
  </div>
</template>

<script>
export default {
  name: 'attr-thousand',
  props: ['component']
}
</script>

<style>
  .thousand{
    border-top: 1px solid #ebebeb;
  }
</style>



// WEBPACK FOOTER //
// src/components/form/componentAttr/thousand.vue